import { Injectable } from '@angular/core';
import { format } from 'date-fns';
import { CheckoutObject, CheckoutQuantityValidationService, CheckoutRow, ValidationAction, ValidationResult } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class JeevesCheckoutQuantityValidationService extends CheckoutQuantityValidationService {
  public getPushDeliveryDateAction(validationResult: ValidationResult): ValidationAction {
    const futureDeliveryDate = this.getFutureAvailability(
      validationResult.availability,
      validationResult.row.quantity
    ).date;
    const futureDeliveryDateStr = format(futureDeliveryDate, 'yyyy-MM-dd');

    return {
      description: this.translateService.instant('PUSH_DELIVERY_DATE') + ' -> ' + futureDeliveryDateStr,
      callback(): void {
        validationResult.row.extra.orp.ordberlevdat = futureDeliveryDateStr;
      }
    };
  }

  public getRowDeliveryDate(row: CheckoutRow, checkout: CheckoutObject): Date {
    if (!row.extra.orp.ordberlevdat) {
      row.extra.orp.ordberlevdat = checkout.extra.oh.ordberlevdat;
    }

    return row.extra.orp.ordberlevdat ? new Date(row.extra.orp.ordberlevdat) : new Date();
  }
}
